<template>
    <NewStoresDashboard></NewStoresDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const NewStoresDashboard = defineAsyncComponent(() =>
    import("../../components/NewStores/Dashboard.vue")
);

export default {
    name: "New_Stores_Dashboard", //The name you are in should not equal the name of the component you are importing.
    components: { NewStoresDashboard, AuthLayout },
};
</script>
